<template>
  <v-container
    class="main"
    fill-height
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <h1>{{ $t('update_browser.txt.title') }}</h1>

        <v-img
          :src="$t('update_browser.img.photo.img')"
          contain
          max-height="400"
          class="my-8"
        />
        <p>{{ $t('update_browser.txt.text') }}</p>
        <v-btn
          href="http://browser-update.org/update-browser.html"
          target="_blank"
          depressed
          large
          class="btn"
        >
          {{ $t('update_browser.txt.button') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: 'UpdateBrowser'
}
</script>

<style lang="scss">
.main {
  text-align: center;
  h1 {
    font-size: 3rem;
    font-weight: normal;
    line-height: normal;
    color: var(--v-dark-base);
    text-align: center;
  }
  p {
    font-size: 0.875rem;
    color: var(--v-slate-base);
    text-align: center;
  }
  .btn {
    background-color: #3182ce !important;
    color: white !important;

    &:hover {
      opacity: 0.9;
    }
  }
}
</style>